import { useMemo } from "react";

import { IntlShape } from "react-intl";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";

import { getActivityStatusOptionDisplayName } from "@app/util/ui";

const useActivityStatusOptions = (
  intl: IntlShape
): {
  label: string;
  value: ActivityStatusOption;
}[] =>
  useMemo(
    () =>
      Object.values(ActivityStatusOption).map((status) => ({
        label: getActivityStatusOptionDisplayName(intl, status),
        value: status,
      })),
    [intl]
  );

export default useActivityStatusOptions;
